import React from "react";

const Footer = () => {
  return (
    <div className="footer absolute left-0 right-0 bottom-0 bg-[#0e1734] text-white p-5 text-sm text-center">
      © {new Date().getFullYear()} Merchant Bay. All rights reserved.
    </div>
  );
};

export default Footer;
